<script lang="ts" setup>
  import { onMounted, ref } from 'vue'

  import { ChatBubbleLeftEllipsisIcon } from '@heroicons/vue/24/solid'
  import { type ResolvedActivity, useGeneratedEffortStore, useGeneratedEmployeeAvatarStore } from '@/stores'
  import AnchorRouter from '@/elements/AnchorRouter.vue'
  import type { EmployeeAvatarJsonldDefaultRead } from '@/api'
  import ButtonRouter from '@/elements/ButtonRouter.vue'

  const props = defineProps<{
    activityItem: ResolvedActivity
  }>()
  const { activity } = props.activityItem
  const { origin } = props.activityItem

  const employeeAvatarStore = useGeneratedEmployeeAvatarStore()
  const effortStore = useGeneratedEffortStore()

  const isLoading = ref(true)

  const originAvatar = ref<EmployeeAvatarJsonldDefaultRead | undefined>()
  const originAvatarUrl = ref<string | undefined>()
  const effort = ref<EffortJsonldVueGlobalSearchDefaultReadSync>()
  onMounted(async () => {
    // const employeeStore = useGeneratedEmployeeStore()

    originAvatar.value = origin?.id ? await employeeAvatarStore.fetchByEmployee({ path: { employee: origin.id.toString() } }).then((d) => d.value) : undefined
    if (originAvatar.value) {
      originAvatarUrl.value = originAvatar.value.avatars?.widget_profile_avatar
    }
    effort.value = await effortStore.fetchByIri(activity.data!.effortId).then((d) => d.value)
    isLoading.value = false
  })
</script>

<template>
  <div
    v-if="!isLoading"
    class="relative flex items-start space-x-3">
    <div class="relative">
      <img
        v-if="originAvatarUrl"
        :src="originAvatarUrl"
        alt=""
        class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-400 ring-8 ring-white" />
      <div
        v-else
        class="h-10 w-10" />
      <span class="absolute -bottom-0.5 -right-1 rounded-tl bg-white px-0.5 py-px">
        <ChatBubbleLeftEllipsisIcon
          aria-hidden="true"
          class="h-5 w-5 text-gray-400" />
      </span>
    </div>
    <div class="min-w-0 flex-1">
      <div>
        <div class="text-sm">
          {{ origin?.displayname ?? '' }}
        </div>
        <p class="mt-0.5 text-sm text-gray-500">
          {{ $formatter.DateTime(activity.createdAt!) }}
        </p>
      </div>
      <div class="mt-2 text-sm text-gray-700">
        <p>
          Leistung auf
          <AnchorRouter :to="{ name: 'effort_details', params: { id: activity.data!['effortId'] } }">
            {{ effort!.title }}
          </AnchorRouter>
          erfasst
        </p>
        <ButtonRouter
          v-if="$titrop.user.roles.management"
          :to="{ name: 'effort_entry_details', params: { id: activity.data!['effortEntryId'] } }"
          class="text-xs !p-1">
          Eintragdetails
        </ButtonRouter>
      </div>
    </div>
  </div>
</template>
